import { CSSProperties } from "react";
import styled from "styled-components";
import { Button as ButtonUi, Box, Grid } from "@mui/material";

export const Container = styled.div`
  padding: 0 6%;
  display: flex;
  justify-content: center;
  .verify {
    background: var(--action-accent-surface);
    width: 15em;
    height: 4em;
    border: none;
    margin-left: auto;
  }

  .hide {
    display: none;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h4`
  font-weight: 500;
  font-size: 31px;
  line-height: 36px;
  color: var(--text-primary);
  margin: 40px 10px;
  width: 100%;
  text-align: left;
`;

export const SubTitle = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0.18px;
  color: var(--text-primary);
  display: inline-block;
  margin-bottom: 30px;
`;

export const UploadForm = styled.form`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
`;

export const FormField = styled.div`
  width: fit-content;
  display: flex;
`;

export const Text = styled.span`
  max-width: 140px;
  min-width: 140px;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  margin: 0 20px;
`;

export const Input = styled.input`
  display: none;
`;

export const InputStyled: CSSProperties = {
  maxWidth: "360px",
  minWidth: "140px",
  marginRight: "30px",
};

export const InputFormStyled: CSSProperties = {
  maxWidth: "360px",
  minWidth: "140px",
};

export const Load = styled.div`
  background: var(--border-accent);
  border-radius: 5px;
  max-width: 20%;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  div {
    margin-left: 15px;
    img {
      width: 30px;
      height: 30px;
    }
  }
  span {
    font-family: var(--font-body);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 1.25px;
    text-transform: capitalize;
    color: var(--text-primary);
  }
`;

export const LoadFile = styled.span`
  display: flex;
`;

export const AddNewFile = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 33px;
  margin-left: 15%;
  cursor: pointer;
`;

export const ContainerForm = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 33px;
`;

export const ContainerTextArea = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 33px;
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 16px;
`;

export const StepCard = styled.div`
  flex: 1;
  min-width: 220px;
  max-width: 240px;
  width: 100%;
  height: 220px;
  background: var(--action-accent-surface);
  border-radius: 25px;
  border: 3px solid var(--action-accent-surface);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  box-shadow: var(--elevation-2);
  transition: all 0.3s ease;
  cursor: pointer;
  font-family: var(--font-body);
  color: var(--text-primary);

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--elevation-3);
  }
`;

export const StepNumber = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
  text-align: justify;
`;

export const StepTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 12px;
  line-height: 1.3;
  text-align: justify;
`;

export const StepDescription = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: var(--info);
  text-align: justify;
`;

export const SectionTitle = styled.div`
  font-weight: 500;
  font-size: 31px;
  line-height: 36px;
  color: var(--text-primary);
  margin: 40px 10px;
`;

export const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background: var(--surface-raised);
  box-shadow: 24px;
  padding: 32px;
  border-radius: 4px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const FileUploadButton = styled(ButtonUi)`
  border-style: dashed !important;
  border-radius: 15px !important;
  text-transform: none !important;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const TitleWithButton = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BackButton = styled(ButtonUi)`
  width: auto !important;
  height: 4em !important;
  margin: 40px 10px !important;
`;

export const MainContainer = styled(Box)`
  display: flex;
  justify-content: left;
  flex-direction: column;
  min-width: 275px;
  width: fit-content;
  max-width: 100%;
`;

export const StepContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GridContainer = styled(Grid)`
  margin-bottom: 2rem !important;
  justify-content: center !important;
`;

export const SubmitContainer = styled.div`
  div {
    &.row {
      div {
        &.col-lg-12 {
          display: flex;
          align-items: center;
        }
      }
    }
  }
`;

export const SubmitButton = styled(ButtonUi)`
  width: 10.4em !important;
`;

export const ClearButton = styled(ButtonUi)`
  width: 10.4em !important;
`;